import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";


// INSERT UPDATE SOLICITUD MOTORISTA 
export const IUPublicSolicitudMotoristas = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/SolicitudMotorista/IU`, 'POST', data, token)
    return result;
}
// GET LIST SOLICITUD MOTORISTA 
export const getPublicListProgramacionMotoristas = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/SolicitudMotorista/GetList`, 'POST', data, token)
    return result;
}
// GET ALL LIST SOLICITUD MOTORISTA 
export const getPublicALListProgramacionMotoristas = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/SolicitudMotorista/GetALLList`, 'POST', data, token)
    return result;
}

// GET LIST SOLICITUD MOTORISTA 
export const ChangePermisoProgramacionMotoristas = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/SolicitudMotorista/ChangePermisoProgramacionMotoristas`, 'POST', data, token)
    return result;
}


// CAMBIAR MOTORISTA O VEHICULO
export const ChangeMotoVehi = async (data, token) => {
    const result = await PublicInterceptor(`Logistica/SolicitudMotorista/changeMotorista`, 'POST', data, token)
    return result;
}